



























































































import tabDescription from "./tabDescription.vue";
import tabClass from "./tabClass.vue";
import tabLog from "./tabLog.vue";
import {
  teacherdetail,
  classlist,
  rollCallListData,
  rollCallList,
} from "@/api/teacherManage";
import { rollCallStudentList } from "@/api/rollCall";
import {
  staffList,
  geteacherList,
  getSelectClassList,
  getSelectCourseList,
  autoSearchData,
} from "@/api/globalSearch";
import { dateFormat } from "@/utils/timeFormat";
import { Component, Prop, Vue } from "vue-property-decorator";
import { PageModule } from "@/store/module/page";
@Component({
  name: "teacherDetails",
  components: {
    tabDescription,
    tabClass,
    tabLog,
  },
})
export default class extends Vue {
  id = 0;
  activeName = "tabDescription";
  detailsData = {
    subjects: [],
    directly_under: 0,
  }; //总数据
  tableData = [];
  page = 1;
  pageSize = 3;
  pageSizeArray = [3, 10, 20];
  total = 5;
  searchInfo = {
    course_id: "",
  }; //授课班级搜索
  dialogVisible = false;
  courseName = ""; //课程名字
  className = ""; //班级名字
  expireTime = ""; //到期时间
  expireTimeClass = ""; //课次时间
  tabledialogData = [];
  dialogtotal = 5;
  dialogpage = "";
  dialogpageSize = 10;
  roll_call_id = "";
  dataLoaded = false;
  classNameDilo = "";
  created() {
    const _t = this;
    _t.id = Number(_t.$route.query.id);
    _t.getDataDetails({ staff_id: _t.id }, () => {
      _t.dataLoaded = true;
    });
    const cache = PageModule.pageInfo.teacherDetails;
    if (cache.tab) {
      this.activeName = cache.tab;
      this.getListData();
    } else {
      this.activeName = "tabDescription";
      PageModule.SET_PAGE_INFO({
        name: "teacherDetails",
        key: "tab",
        value: "tabDescription",
      });
    }
    _t.globalSearch("", "course");
    _t.globalSearch("", "class");
  }
  lookDetails(e: any) {
    const _t = this as any;
    _t.$router.push({
      name: "classManageDetail",
      query: {
        id: e.class_id,
      },
    });
  }
  lookDetailsrollist(e: any) {
    const _t = this;
    _t.roll_call_id = e.roll_call_id;
    _t.classNameDilo = e.class.name;
    const data = {
      page: 1,
      page_size: 10,
    };
    _t.getrollcallstudentlist(data);
  }
  getrollcallstudentlist(data: rollCallListData) {
    const _t = this as any;
    data.roll_call_id = _t.roll_call_id;
    rollCallStudentList(data).then((res: any) => {
      if (res.error_code == 0) {
        _t.dialogVisible = true;
        res.data.list.map((a: any) => {
          a.remark = a.remark == "" ? "无" : a.remark;
          switch (a.student_status) {
            case 1:
              a.student_status = "到课";
              break;
            case 2:
              a.student_status = "迟到";
              break;
            case 3:
              a.student_status = "请假";
              break;
            case 4:
              a.student_status = "未到";
              break;
          }
        });
        _t.tabledialogData = res.data.list;
        _t.dialogtotal = res.data.total;
        _t.dialogpage = res.data.page;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  edit() {
    this.$router.push({
      name: "editEmployee",
      query: {
        id: this.id + "",
      },
    });
  }
  lookDetailsedit(e: any) {
    this.$router.push({
      name: "rollCallDetails",
      query: { id: e.roll_call_id },
    });
  }
  // 通用搜索框
  getglobalsearchdata(data: autoSearchData, type: String) {
    if (type == "staff") {
      return staffList(data);
    } else if (type == "teacher") {
      return geteacherList(data);
    } else if (type == "class") {
      return getSelectClassList(data);
    } else if (type == "course") {
      return getSelectCourseList(data);
    }
  }
  async globalSearch(queryString: string, type: string) {
    const _t = this;
    let data: autoSearchData = {
      page: 1,
      page_size: 100,
    };
    let restaurants: any = {};
    if (queryString) {
      data = {
        page: 1,
        page_size: 10,
      };
      if (type == "class") {
        data.name = queryString;
      } else if (type == "course") {
        data.title = queryString;
      } else {
        data.key_word = queryString;
      }
    }
    restaurants = await _t.getglobalsearchdata(data, type);
    const list = restaurants.data.list;
    if (type == "staff") {
      //
    } else if (type == "teacher") {
      //
    } else if (type == "class") {
      _t.className = list;
    } else if (type == "course") {
      _t.courseName = list;
    }
  }
  // 通用搜索框结束
  getDataDetails(data: { staff_id: number }, cb: Function) {
    const _t = this as any;
    teacherdetail(data).then((res: any) => {
      if (res.error_code == 0) {
        _t.detailsData = res.data;
        if (cb) {
          cb();
        }
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  //上课记录
  getClasslistData(data: rollCallListData) {
    const _t = this as any;
    data.teacher_id = _t.id;
    if (_t.searchInfo.class_id) {
      data.class_id = _t.searchInfo.class_id;
    }
    if (_t.searchInfo.course_id) {
      data.course_id = _t.searchInfo.course_id;
    }
    if (_t.searchInfo.class_id) {
      data.class_id = _t.searchInfo.class_id;
    }
    if (_t.searchInfo.staff_id) {
      data.staff_id = _t.searchInfo.staff_id;
    }
    if (_t.searchInfo.roll_call_start_date) {
      data.roll_call_start_date = _t.searchInfo.roll_call_start_date;
    }
    if (_t.searchInfo.roll_call_end_date) {
      data.roll_call_end_date = _t.searchInfo.roll_call_end_date;
    }
    if (_t.searchInfo.lesson_start_date) {
      data.lesson_start_date = _t.searchInfo.lesson_start_date;
    }
    if (_t.searchInfo.lesson_end_date) {
      data.lesson_end_date = _t.searchInfo.lesson_end_date;
    }
    rollCallList(data).then((res: any) => {
      if (res.error_code == 0) {
        if (res.data.list != null) {
          res.data.list.map((a: any) => {
            a.create_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(Number(a.create_time + "000"))
            );
          });
        }
        _t.tableData = res.data.list;
        _t.total = res.data.total;
        _t.page = res.data.page;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  //授课班级
  classlistData(data: { page: number; page_size: number; staff_id: number }) {
    const _t = this as any;
    data.staff_id = _t.id;
    classlist(data).then((res: any) => {
      if (res.error_code == 0) {
        _t.tableData = res.data.list;
        _t.total = res.data.total;
        _t.page = res.data.page;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  // 返回上一页
  goBack() {
    this.$router.go(-1);
  }
  //切换请求数据
  getListData() {
    const _t = this as any;
    switch (_t.activeName) {
      case "tabClass":
        _t.classlistData({
          page: _t.page,
          page_size: _t.pageSize,
        });
        break;
      case "tabLog":
        _t.getClasslistData({
          page: _t.page,
          page_size: _t.pageSize,
        });
        break;
    }
    PageModule.SET_PAGE_INFO({
      name: "teacherDetails",
      key: "tab",
      value: _t.activeName,
    });
  }
  handleClick() {
    const _t = this as any;
    _t.page = 1;
    _t.pageSize = 20;
    _t.getListData();
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getListData();
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getListData();
  }
  handledialogChange(e: number) {
    const _t = this as any;
    _t.dialogpage = e;
    _t.getrollcallstudentlist({
      page: _t.dialogpage,
      page_size: _t.dialogpageSize,
    });
  }
  handledialogSizeChange(e: number) {
    const _t = this as any;
    _t.dialogpageSize = e;
    _t.getrollcallstudentlist({
      page: _t.dialogpage,
      page_size: _t.dialogpageSize,
    });
  }
  handleSearch() {
    const _t = this as any;
    _t.getClasslistData({
      page: _t.page,
      page_size: _t.pageSize,
    });
  }
  datechoose(e: { 0: string; 1: string }) {
    const _t = this as any;
    let expire_start_time: number | String = "";
    let expire_end_time: number | String = "";
    if (e != null) {
      expire_start_time = e[0];
      expire_end_time = e[1];
    }
    _t.searchInfo.roll_call_start_date = expire_start_time;
    _t.searchInfo.roll_call_end_date = expire_end_time;
    _t.handleSearch();
  }
  datechooseClass(e: { 0: string; 1: string }) {
    const _t = this as any;
    let expire_start_time: number | String = "";
    let expire_end_time: number | String = "";
    if (e != null) {
      expire_start_time = e[0];
      expire_end_time = e[1];
    }
    _t.searchInfo.lesson_start_date = expire_start_time;
    _t.searchInfo.lesson_end_date = expire_end_time;
    _t.handleSearch();
  }
}
